import { Inject, Injectable, InjectionToken } from '@angular/core';

export const DRCHRONO_URL = new InjectionToken<string>('DRCHRONO_URL');

@Injectable({ providedIn: 'root' })
export class DrchronoClient {
  constructor(@Inject(DRCHRONO_URL) private readonly drchronoUrl: string) {}

  authUrl(clientId: string, scope: string, redirect: string): string {
    const url = new URL(this.drchronoUrl);
    url.pathname += 'o/authorize/';
    url.searchParams.set('client_id', clientId);
    url.searchParams.set('redirect_uri', redirect);
    url.searchParams.set('response_type', 'code');
    url.searchParams.set('scope', scope);
    return url.toString();
  }
}
